import React, { useEffect, useState } from "react";

import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";

import { Container, CircularProgress, Alert } from "@mui/material";
import { verifyEmail } from "../api/users";  // Використовуємо API-функцію
import { useTranslation } from "react-i18next";


const VerifyEmailPage = () => {
    const { t } = useTranslation("common");
    const { token } = useParams();  // Отримуємо токен із URL
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        const handleVerification = async () => {
            try {
                const response = await verifyEmail(token);
                setMessage(response.message);
            } catch (err) {
                setError(err.error || t("verifyEmail.error"));
            } finally {
                setLoading(false);
            }
        };

        handleVerification();
    }, [token, t]);

    return (
        <Box sx={{height: '80vh', justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
        {!token && (
        <Box sx={{ maxWidth: 500, margin: "0 auto", p: 3, textAlign: "center" }}>
            <EmailIcon sx={{ fontSize: 60, color: "primary.main", mb: 2 }} />
            <Typography variant="h5" fontWeight="bold" mb={2}>
                {t("verifyEmail.title")}
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
                {t("verifyEmail.body")}
            </Typography>

            <Button variant="contained" color="primary" onClick={() => navigate("/")}>
                {t("verifyEmail.goHome")}
            </Button>
        </Box>
        )}

        {token && (
        <Container maxWidth="sm" sx={{ textAlign: "center" }}>
            <Box sx={{ m: 'auto' }}>
            {loading && <CircularProgress />}
            {!loading && message && <Alert severity="success">{message}</Alert>}
            {!loading && error && <Alert severity="error">{error}</Alert>}

            {!loading && (
                <Button
                    variant="contained"
                    color="primary"
                    sx={{ mt: 3 }}
                    onClick={() => navigate("/login")}
                >
                    {t("verifyEmail.goLogin")}
                </Button>
            )}
            </Box>
        </Container>
        )}
        </Box>
    );
};

export default VerifyEmailPage;
